enum AvailabilityEnum {
	ANY_DAY = 'any-day',
	RESTRICTION = 'restriction',
}

enum TypeOfConsultationEnum {
	TELE_OR_IN_PERSON = 'Aceito teleconsulta e presencial',
	ONLY_IN_PERSON = 'Aceito apenas presencial',
}

const REQUEST_SCHEDULE_DEFAULT_VALUES = {
	whatsappUpdates: false,
	availability: AvailabilityEnum.ANY_DAY,
	typeOfConsultation: TypeOfConsultationEnum.TELE_OR_IN_PERSON,
	morning: {
		active: false,
		days: {
			monday: false,
			tuesday: false,
			wednesday: false,
			thursday: false,
			friday: false,
			saturday: false,
			sunday: false,
		},
	},
	afternoon: {
		active: false,
		days: {
			monday: false,
			tuesday: false,
			wednesday: false,
			thursday: false,
			friday: false,
			saturday: false,
			sunday: false,
		},
	},
	night: {
		active: false,
		days: {
			monday: false,
			tuesday: false,
			wednesday: false,
			thursday: false,
			friday: false,
			saturday: false,
			sunday: false,
		},
	},
};

export {AvailabilityEnum, REQUEST_SCHEDULE_DEFAULT_VALUES, TypeOfConsultationEnum};
